<i class="vitamui-icon {{ hasDiscussion() ? 'vitamui-icon-ic24-dialog' : 'vitamui-icon-ic24-dialog-plain' }}"></i>
@if (hasUnread()) {
  <i class="green badge"></i>
}
